export const getOnlyNumbersFromString = (str) => (str || '').replace(/\D/g, '')